'use client'

import React from 'react'

import Control from './controls'

export default function MediaControllBarComponent ({
  isLandscapeVideo,
  ...props
}) {
  // To hide all the player controls
  const _hidePlayerControl = props.controls?.disablePlayerControls || false

  return (
    !_hidePlayerControl
      ? <Control
          isLandscapeVideo={isLandscapeVideo}
          {...props}
        />
      : <></>
  )
}
